/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const AnnouncementFormPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    if (isEdit) {
      axios.get(`/api/announcements/${id}`)
        .then(res => {
          const ann = res.data;
          setTitle(ann.title);
          setContent(ann.content);
          setStartDate(ann.startDate ? ann.startDate.slice(0,10) : '');
          setEndDate(ann.endDate ? ann.endDate.slice(0,10) : '');
        })
        .catch(console.error);
    }
  }, [id, isEdit]);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const payload = { title, content, startDate, endDate };
      if (isEdit) {
        await axios.put(`/api/announcements/${id}`, payload);
      } else {
        await axios.post('/api/announcements', payload);
      }
      navigate('/dashboard/admin/announcements');
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || 'Error saving announcement.');
    }
  };

  return (
    <div className="p-6 max-w-md">
      <h1 className="text-2xl mb-4">{isEdit ? 'Edit' : 'New'} Announcement</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Title</label>
          <input
            className="w-full border p-2"
            value={title}
            onChange={e => setTitle(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block mb-1">Content</label>
          <textarea
            className="w-full border p-2"
            value={content}
            onChange={e => setContent(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block mb-1">Start Date</label>
          <input
            type="date"
            className="w-full border p-2"
            value={startDate}
            onChange={e => setStartDate(e.target.value)}
          />
        </div>
        <div>
          <label className="block mb-1">End Date</label>
          <input
            type="date"
            className="w-full border p-2"
            value={endDate}
            onChange={e => setEndDate(e.target.value)}
          />
        </div>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
          {isEdit ? 'Update' : 'Create'}
        </button>
      </form>
    </div>
  );
};

export default AnnouncementFormPage;
